module.exports = __webpack_public_path__ + "img/wave.edfdd94f.svg";